import React, {Component} from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCali from '../components/MenuCali';
import Sponsors from '../components/Sponsors';
import GalleryComponent from '../components/GalleryComponent';

class Gallery extends Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      data: {},
    }
  }

  componentDidMount() {
    fetch('https://legendofeldorado.com/series-admin-temporal/api/gallery_race/cali')
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({
          isLoaded: true,
          data: res,
        });
      },

      (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      }
    )

  }

  render(){
    const { photos, sponsors } = this.state.data;

    return(
      <Layout>
        <Banner id={11} city="cali" thumb="/cali/logo_cali.PNG" />
        <MenuCali />
        <div className="row content-cali">
          <div className="container" id="contenido_video">
            <div className="row">
              <div className="col-12">
                {photos && 
                  <GalleryComponent city="cali" images={photos}/>
                }
              </div>
            </div>
          </div>
        </div>
        {sponsors && 
          <Sponsors
          customClass="--cali"
          items={sponsors}
          />
        }
      </Layout>
      )
    }
  }

export default Gallery;
